// File: pages/Register.js
import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
} from "reactstrap";
import ReCAPTCHA from "react-google-recaptcha";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";

// service
import { registerUser } from "../../services/registerService";

// import images
import profileImg from "../../assets/images/profile-img.png";
import logoImg from "../../assets/images/logo.svg";

const Register = () => {
  const navigate = useNavigate();
  const [captchaToken, setCaptchaToken] = useState(null);
  const [success, setSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null); // State baru untuk pesan sukses
  const [registrationError, setRegistrationError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Register";
  }, []);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      fullname: "",
      phone: "",
      password: "",
      confirmpassword: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email")
        .required("Please Enter Your Email"),
      fullname: Yup.string().required("Please Enter Your Full Name"),
      phone: Yup.string().required("Please Enter Your Phone Number"),
      password: Yup.string().required("Please Enter Your Password"),
      confirmpassword: Yup.string()
        .required("Please Confirm Your Password")
        .oneOf([Yup.ref("password"), null], "Passwords must match"),
    }),
    onSubmit: async (values) => {
      if (!captchaToken) {
        alert("Harap selesaikan captcha terlebih dahulu!");
        return;
      }
      setLoading(true);
      setRegistrationError(null);
      setSuccessMessage(null); // Reset pesan sukses saat submit
      try {
        const payload = {
          full_name: values.fullname,
          nomor_hp: values.phone,
          email: values.email,
          password: values.password,
          captchaToken: captchaToken,
        };

        await registerUser(payload);
        setSuccess(true);
        setSuccessMessage("Pendaftaran berhasil! Silakan cek email Anda untuk verifikasi akun.");
        
        // Opsional: Redirect setelah beberapa detik
        // setTimeout(() => navigate("/login"), 5000); 
        
      } catch (err) {
        setSuccess(false);
        setRegistrationError(err.response?.data?.message || "Register failed");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Register Disini</h5>
                        <p>Silahkan masukkan data anda</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profileImg} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logoImg}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <Form
                      className="form-horizontal"
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      {successMessage && (
                        <Alert color="success">{successMessage}</Alert>
                      )}

                      {registrationError && (
                        <Alert color="danger">{registrationError}</Alert>
                      )}

                      <div className="mb-3">
                        <Label className="form-label">Full Name</Label>
                        <Input
                          name="fullname"
                          type="text"
                          placeholder="Enter Full Name"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.fullname || ""}
                          invalid={
                            validation.touched.fullname &&
                            validation.errors.fullname
                              ? true
                              : false
                          }
                        />
                        <FormFeedback>{validation.errors.fullname}</FormFeedback>
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Phone Number</Label>
                        <Input
                          name="phone"
                          type="text"
                          placeholder="Enter Phone Number"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.phone || ""}
                          invalid={
                            validation.touched.phone &&
                            validation.errors.phone
                              ? true
                              : false
                          }
                        />
                        <FormFeedback>{validation.errors.phone}</FormFeedback>
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Email</Label>
                        <Input
                          id="email"
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email &&
                            validation.errors.email
                              ? true
                              : false
                          }
                        />
                        <FormFeedback>{validation.errors.email}</FormFeedback>
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Password</Label>
                        <Input
                          name="password"
                          type="password"
                          placeholder="Enter Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.password || ""}
                          invalid={
                            validation.touched.password &&
                            validation.errors.password
                              ? true
                              : false
                          }
                        />
                        <FormFeedback>{validation.errors.password}</FormFeedback>
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">Konfirmasi Password</Label>
                        <Input
                          name="confirmpassword"
                          type="password"
                          placeholder="Enter Confirm Password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.confirmpassword || ""}
                          invalid={
                            validation.touched.confirmpassword &&
                            validation.errors.confirmpassword
                              ? true
                              : false
                          }
                        />
                        <FormFeedback>
                          {validation.errors.confirmpassword}
                        </FormFeedback>
                      </div>

                      <div className="mb-3">
                        <ReCAPTCHA
                          sitekey={process.env.REACT_APP_SITE_KEY}
                          onChange={(value) => setCaptchaToken(value)}
                        />
                      </div>

                      <div className="mt-4">
                        <button
                          className="btn btn-primary w-100"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? "Loading..." : "Register"}
                        </button>
                      </div>
                    </Form>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Sudah punya akun ?{" "}
                  <Link to="/login" className="font-weight-medium text-primary">
                    Login Disini
                  </Link>
                </p>
                <p>
                  © {new Date().getFullYear()} ASN Kedinasan Learning Center
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Register;